import { Reducable } from "@/classes/Reducable.js";

export class Fee extends Reducable {
  constructor(fee) {
    super(fee);

    this.originalFeeAmount = this.feeAmount;
  }
}
